import React from 'react';
import {
  makeStyles,
  Typography,
} from '@material-ui/core';
import { useTableOverviewContext } from './WhitePopup'

const useStyles = makeStyles((theme) => ({
  root:{
      paddingBottom : theme.spacing(3),
  }
}));

interface WhitePopupTitleProps {
  children : any
}
const WhitePopupTitle: React.FC<WhitePopupTitleProps> = ({
    children
}) => {

    const classes = useStyles();
    const { variant } = useTableOverviewContext();

    return (
        <div className={classes.root}>
            <Typography
                variant={variant === "confirmation" ? "subtitle1" : "h6"}
                style={{
                    color: "black",
                    fontWeight : 600,
                    }}
                align={variant === "confirmation" ? "left" : "center"}
                >
                    {children}
            </Typography>
        </div>
    )
}

export default WhitePopupTitle;
